<!-- success-message.component.html -->
<div class="message-overlay">
    <div class="message-box">
      <div class="message-content">
        <div class="success-icon">✓</div>
        <h3>Success!</h3>  
        <p>{{ successMessage }}</p>
      </div>
      <div class="message-actions">
        <button class="close-btn" (click)="closeMessage()">Close</button>
      </div>
    </div>
</div>

<!-- <div class="message-overlay">
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
    </div>
    <div class="message-box">
      <div class="message-content">
         <h3>Success!</h3>  
      </div>
      <div class="alertext" [innerHTML]="successMessage"></div>
      <div class="center mt-3">
        <button class="btn btn-primary okbtn" (click)="activeModal.close()">OK</button>
      </div>
</div> -->